import OModalDialog from "@/components/organisms/OModalDialog";
import OSettings from "@/components/organisms/OSettings";
export default {
  name: "o-navbar",
  components: {
    OModalDialog,
    OSettings
  },
  props: {
    theme: {
      type: String,
      default() {
        return "light";
      }
    }
  },
  computed: {
    compTheme() {
      if (this.theme === "light") {
        return ["navbar-light", "bg-light", "text-dark"].join(" ");
      } else {
        return ["navbar-dark", "bg-dark", "text-light"].join(" ");
      }
    }
  },
  data() {
    return {
      supportedConstraints: [],
      devices: []
    };
  },
  methods: {
    onSC() {
      let supportedConstraints = navigator.mediaDevices.getSupportedConstraints();

      //this.supportedConstraints = Object.keys(supportedConstraints);
      this.supportedConstraints = supportedConstraints;
    },
    onEnumerateDevices() {
      navigator.mediaDevices.enumerateDevices().then(devices => {
        this.devices = devices;
      });
    }
  }
};